






























































// Vue
import Vue, { PropType } from "vue";
import { mapActions, mapGetters } from "vuex";
// Vuelidate
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
// Models
import { MaterialModel } from "@/core/api/apiClient";
// Services
import AdminService from "@/views/admin/Admin.service";

export default Vue.extend({
  name: "CreateMaterialDialog",
  props: {
    material: Object as PropType<MaterialModel>
  },

  data() {
    return {
      dialog: false,

      name: undefined as string | undefined,
      index: undefined as number | undefined
    };
  },

  mixins: [validationMixin],

  validations: {
    name: { required }
  },

  methods: {
    ...mapActions("appMessages", {
      ADD_ERROR_MESSAGE: "ADD_ERROR_MESSAGE",
      ADD_SUCCESS_MESSAGE: "ADD_SUCCESS_MESSAGE"
    }),

    init(): void {
      if (this.material) {
        this.name = this.material.name;
        this.index = this.material.index;
      }
    },

    submit(): void {
      if (!this.name) return;

      const payload = new MaterialModel({
        materialId: this.material.materialId,
        clientId: this.material.clientId,
        name: this.name,
        index: this.index!
      });

      // * Submit to server
      AdminService.updateMaterial(this.currentUser.clientId, payload)
        .then(() => {
          this.$emit("refresh-materials");
          this.close();
          this.ADD_SUCCESS_MESSAGE("Material successfully updated.");
        })
        .catch((error) => {
          console.log(error);
          this.ADD_ERROR_MESSAGE("Error updating material. Please try again.");
        });

      this.close();
    },

    close(): void {
      this.name = undefined;

      this.$v.$reset();
      this.dialog = false;
    }
  },

  computed: {
    ...mapGetters({ currentUser: "currentUser" }),

    nameErrors(): string[] {
      const errors: string[] = [];
      if (!this.$v.$dirty) return errors;
      !this.$v.name.required && errors.push("Name is required");
      return errors;
    }
  }
});
